import axios from 'axios';

// Empty baseURL lets CRA's proxy (http://localhost:8269) handle dev requests.
// Override via REACT_APP_API_BASE for other deployments.
const API_BASE = process.env.REACT_APP_API_BASE || '';
const http = axios.create({ baseURL: API_BASE });

export async function getAvailableDates() {
  const { data } = await http.get('/available_dates');
  return data.dates || [];
}

export async function getForecastLines(date) {
  const { data } = await http.get(`/forecast_lines/${date}`);
  return data;
}

export async function getForecastWindow(sheetDate) {
  const { data } = await http.get(`/forecast_window/${sheetDate}`);
  return data;
}

export async function getMonthlyHigh(month) {
  const { data } = await http.get(`/monthly_high/${month}`);
  return data;
}

export async function getHighestActuals(month) {
  const { data } = await http.get(`/highest_actuals/${month}`);
  return data;
}

export async function getTemperatures(date) {
  const { data } = await http.get(`/temperatures/${date}`);
  return data;
}

export async function getPricesRange(start, end) {
  const { data } = await http.get('/prices_range', { params: { start, end } });
  return data;
}

export async function getActualsRange(start, end) {
  const { data } = await http.get('/actuals_range', { params: { start, end } });
  return data;
}

export async function getTemperaturesRange(start, end) {
  const { data } = await http.get('/temperatures_range', { params: { start, end } });
  return data;
}

export async function getHiddenPeakRisk(series, daysAhead = 15) {
  const { data } = await http.get('/hidden_peak_risk', {
    params: { series, days_ahead: daysAhead },
  });
  return data;
}

export async function notifyDiscord(webhookUrl, content, mentionUserId = '') {
  const { data } = await http.post('/notify/discord', {
    webhook_url: webhookUrl,
    content,
    mention_user_id: mentionUserId || null,
  });
  return data;
}

export async function getCurtailmentConfig() {
  const { data } = await http.get('/curtailment_config');
  return data;
}

export async function getCurtailments() {
  const { data } = await http.get('/curtailments');
  return data;
}

export async function createCurtailment(payload) {
  const { data } = await http.post('/curtailments', payload);
  return data;
}

export async function cancelCurtailment(id) {
  const { data } = await http.post(`/curtailments/${id}/cancel`);
  return data;
}

export async function deleteCurtailment(id) {
  const { data } = await http.delete(`/curtailments/${id}`);
  return data;
}

export async function getMinerFleet() {
  const { data } = await http.get('/miner_fleet');
  return data;
}

export async function getForemanStatus() {
  const { data } = await http.get('/foreman_status');
  return data;
}

export async function getCurtailmentLocations() {
  const { data } = await http.get('/curtailment_locations');
  return data;
}

export async function getCurtailmentEmailConfig() {
  const { data } = await http.get('/curtailment_email_config');
  return data;
}

export async function saveCurtailmentEmailConfig(recipients) {
  const { data } = await http.post('/curtailment_email_config', { recipients });
  return data;
}

export async function testCurtailmentEmail() {
  const { data } = await http.post('/curtailment_email_test');
  return data;
}

export async function getBillingViews() {
  const { data } = await http.get('/billing_views');
  return data;
}

export async function getLocationAssignments() {
  const { data } = await http.get('/location_assignments');
  return data;
}

export async function saveLocationAssignments(assignments) {
  const { data } = await http.post('/location_assignments', { assignments });
  return data;
}

export async function setCurtailmentDryRun(dryRun) {
  const { data } = await http.post('/curtailment_config', { dry_run: dryRun });
  return data;
}

export async function resumeCurtailment(id) {
  const { data } = await http.post(`/curtailments/${id}/resume`);
  return data;
}

export async function getAuthStatus() {
  const { data } = await http.get('/auth/status');
  return data;
}
